import { Link } from 'react-router-dom';
import { TransportOrdersProfitSummary } from '../../components/TransportOrdersProfitSummary';
import { CurrencyRecord } from '../../domain/currency';
import { TransportOrder } from '../../domain/transportOrder';
import { useLoggedInUser } from '../users/LoggedInUserProvider';

type DispatcherProfitForMonthProps = {
    transportOrders: Array<TransportOrder>;
    currencyRecord: CurrencyRecord;
    month: number;
    year: number;
    className?: string;
}

export const DispatcherProfitForMonth = ({ transportOrders, currencyRecord, month, year, className = '' }: DispatcherProfitForMonthProps) => {
    const { loggedInUser } = useLoggedInUser();

    if (transportOrders.length === 0) {
        return null;
    }

    const displayedMonthNumber = month < 10 ? `0${month}` : month;

    return <h6 className={`text-black-50 fst-italic ${className}`}>
        Marża <Link to={`/stats?timePeriod=single-month&year=${year}&month=${month}&creatorId=${loggedInUser.sub}`}>{displayedMonthNumber}-{year}</Link> to <TransportOrdersProfitSummary transportOrders={transportOrders} currencyRecord={currencyRecord} />
    </h6>;
};